"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Message_1 = require("@/pages/common/components/Message");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var Enquire_1 = require("@/pages/common/components/Enquire");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var react_intl_1 = require("react-intl");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var styles_1 = require("@/pages/articleDetail/styles");
var CallOrEmail_1 = require("@/pages/common/components/CallOrEmail");
var actions_1 = require("@/pages/common/components/contact/actions");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var Login_1 = require("@/pages/common/components/Login");
var ArticleHeader_1 = require("@/pages/articleDetail/components/ArticleHeader/ArticleHeader");
var ArticleContent_1 = require("@/pages/articleDetail/components/ArticleContent/ArticleContent");
var ArticleFooter_1 = require("@/pages/articleDetail/components/ArticleFooter/ArticleFooter");
var RelatedArticles_1 = require("@/pages/articleDetail/components/RelatedArticles/RelatedArticles");
var Contact_1 = require("@/pages/common/components/contact/Contact");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Signup_1 = require("@/pages/common/components/Signup");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var mapStateToProps = function (state) { return (__assign({}, state)); };
var mapDispatchToProps = function (dispatch) { return ({
    onEnquireClicked: function (item) {
        return dispatch(ResultAction_1.default.onEnquireClicked(item));
    },
    onContactFormClicked: function () { return dispatch(actions_1.default.onContactFormClicked()); },
}); };
var page = function (_a) {
    var intl = _a.intl, layout = _a.layout, newsArticleDetail = _a.newsArticleDetail, newsAndInsights = _a.newsAndInsights, resultPageTranslation = _a.resultPageTranslation, onContactFormClicked = _a.onContactFormClicked, onEnquireClicked = _a.onEnquireClicked, page = _a.page, props = __rest(_a, ["intl", "layout", "newsArticleDetail", "newsAndInsights", "resultPageTranslation", "onContactFormClicked", "onEnquireClicked", "page"]);
    var language = layout.language.languages.filter(function (it) { return it.id === layout.language.current; })[0];
    var languageCode = language.code1;
    var appClasses = classnames_1.default([
        'l-arch',
        'js-scombo-sort__anchor',
        'js-saction-view__anchor',
        'js-scombo-filter__anchor',
        'js-sfilter__anchor',
        'js-sfilter-district__anchor',
        'js-side-setting-toggle__anchor',
        'js-side-nav-toggle__anchor',
        'js-fav-toggle__anchor',
        {
            'c-nav--safari': true,
            'l-arch__topmenu--nosticky': true,
            'c-sfilter__pop--active': props.sfilter
                ? props.sfilter.district.opened
                : false,
            'c-nav__menu-main--mobile-active': layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-nav__menu-setting--mobile-active': layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
            'c-calloremail--active': layout.callOrEmailActive,
        },
    ]);
    var loadingClass = classnames_1.default([
        'l-arch__loading',
        {
            'l-arch__loading--active': layout.isLoading,
        },
    ]);
    var renderRelatedArticles = function () {
        return newsAndInsights.newsAndInsights &&
            newsAndInsights.newsAndInsights.length > 0 && (React.createElement(styles_1.RelatedArticlesContainer, null,
            React.createElement(styles_1.Root, null,
                React.createElement(styles_1.Container, null,
                    React.createElement(styles_1.Content, null,
                        React.createElement(RelatedArticles_1.RelatedArticles, { newsAndInsights: newsAndInsights, languageCode: languageCode }))))));
    };
    return (React.createElement("div", { className: appClasses, style: { overflowX: 'hidden' } },
        React.createElement("div", { className: loadingClass },
            React.createElement("div", null,
                React.createElement("span", { className: "fal fa-sync fa-spin" }))),
        React.createElement(Message_1.default, null),
        !props.nomenu ? React.createElement("div", { className: "l-arch__topmenu" },
            React.createElement(MegaMenu_1.default, null)) : null,
        React.createElement(styles_1.Root, null,
            React.createElement(styles_1.Container, null,
                React.createElement(Breadcrumb_1.default, null),
                React.createElement(styles_1.Content, null,
                    React.createElement(ArticleHeader_1.ArticleHeader, { newsArticleDetail: newsArticleDetail }),
                    React.createElement(ArticleContent_1.ArticleContent, { newsArticleDetail: newsArticleDetail }),
                    React.createElement(ArticleFooter_1.ArticleFooter, { newsArticleDetail: newsArticleDetail })))),
        renderRelatedArticles(),
        React.createElement(Contact_1.default, { mobileHidden: false }),
        React.createElement(Enquire_1.default, null),
        React.createElement(CallOrEmail_1.default, null),
        React.createElement(Megafoot_1.default, null),
        React.createElement(Signup_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(ExistingLogin_1.default, null),
        React.createElement(ServerSideSchema_1.default, null)));
};
var enhance = recompose_1.compose(react_intl_1.injectIntl, react_redux_1.connect(mapStateToProps, mapDispatchToProps));
exports.default = enhance(page);
